<template>
  <v-card outlined class="ma-2" elevation="2">
    <v-card-title class="text-h5 title-header"
      >{{ $t("llm_config.number_of_chunks_analyzed.title") }}
    </v-card-title>
    <v-card-subtitle
      class="red--text ma-2"
      v-html="$t('llm_config.number_of_chunks_analyzed.subtitle')"
    ></v-card-subtitle>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-card outlined class="pa-6">
            <v-slider
              v-model="max_chunks"
              thumb-label="always"
              :max="1000"
              :min="20"
              :step="1"
              :label="$t('llm_config.number_of_chunks_analyzed.label')"
              persistent-hint
              color="#1141ce"
            >
              <template v-slot:append>
                <v-text-field
                  v-model="max_chunks"
                  class="mt-0 pt-0"
                  type="number"
                  style="width: 60px"
                  :rules="form_roles.number"
                ></v-text-field>
              </template>
            </v-slider>
            <span v-html="$t('llm_config.number_of_chunks_analyzed.hint')">
            </span>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NumberOfChunksAnalyzed",
  props: {
    openaiConfig: {
      type: Object,
      required: true,
    },
    form_roles: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultValue: 100,
    };
  },
  created() {
    if (!this.openaiConfig.langchain_settings?.max_chunks) {
      this.$set(
        this.openaiConfig.langchain_settings,
        "max_chunks",
        this.defaultValue
      );
    }
  },
  computed: {
    max_chunks: {
      get() {
        return (
          this.openaiConfig.langchain_settings?.max_chunks || this.defaultValue
        );
      },
      set(value) {
        value = Number(value);
        this.$set(this.openaiConfig.langchain_settings, "max_chunks", value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.title-header {
  font-weight: bold;
  color: #1141ce !important;
}
</style>
